/** Bật UI + API v2 multi-voucher trên POS hóa đơn bán lẻ */
export const ENABLE_MULTI_VOUCHER_RETAIL =
  String(process.env.VUE_APP_ENABLE_MULTI_VOUCHER_RETAIL || 'true').toLowerCase() === 'true';

export const MAX_VOUCHERS_PER_LINE = 5;
